
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 23","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.473 4.855a2.432 2.432 0 00-1.895-.935H6.192l-.48-1.87A2.429 2.429 0 003.362.206H.783A.787.787 0 000 .989c0 .43.353.784.784.784H3.36c.38 0 .708.252.808.632l3.084 12.28a2.428 2.428 0 002.35 1.845h10.079c1.112 0 2.099-.758 2.352-1.844l1.893-7.784a2.317 2.317 0 00-.456-2.049l.002.002zm-1.085 1.692l-1.896 7.784a.835.835 0 01-.808.63H9.602a.833.833 0 01-.809-.63L6.595 5.512H21.58a.84.84 0 01.658.329.793.793 0 01.15.707v-.001zM10.134 17.539a2.643 2.643 0 00-2.628 2.628 2.642 2.642 0 002.628 2.627 2.64 2.64 0 002.628-2.627 2.643 2.643 0 00-2.628-2.628zm0 3.664a1.026 1.026 0 01-1.037-1.037c0-.58.456-1.035 1.037-1.035.58 0 1.035.454 1.035 1.035 0 .557-.48 1.037-1.035 1.037zm8.691-3.663a2.643 2.643 0 00-2.628 2.627 2.642 2.642 0 002.628 2.627 2.643 2.643 0 002.628-2.628c-.025-1.44-1.188-2.628-2.628-2.628v.002zm0 3.663a1.026 1.026 0 01-1.037-1.037c0-.58.456-1.035 1.037-1.035.582 0 1.037.454 1.037 1.035 0 .557-.48 1.037-1.037 1.037z"}})])
          )
        }
      }
    